import { useEffect, useState } from "react";
import { resolveMediaUrl } from "../../api";
import { formatPrice } from "../../shop/formatPrice";
import QuantityStepper from "./QuantityStepper";
import { IconBag, IconClose } from "./ShopIcons";

function ProductModal({ product, t, lang, onClose, onAdd }) {
  const [quantity, setQuantity] = useState(1);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    function handleKeyDown(event) {
      if (event.key === "Escape") onClose();
    }

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  const name = (lang === "en" && product.nameEn) || product.nameHu;
  const description = (lang === "en" && product.descriptionEn) || product.descriptionHu;

  return (
    <div
      className="shop-modal-backdrop"
      role="presentation"
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="shop-modal" role="dialog" aria-modal="true" aria-labelledby="shop-modal-title">
        <button type="button" className="shop-icon-btn shop-modal-close" onClick={onClose} aria-label={t.close}>
          <IconClose />
        </button>

        <div className="shop-modal-media">
          <img
            src={product.imageUrl ? resolveMediaUrl(product.imageUrl) : "/img/mizulogo.png"}
            alt=""
            className={product.imageUrl ? "" : "shop-card-placeholder"}
          />
        </div>

        <div className="shop-modal-body">
          <p className="shop-card-category">{t.categories[product.category] || ""}</p>
          <h2 id="shop-modal-title" className="shop-modal-title">
            {name}
          </h2>
          <p className="shop-modal-price">
            {formatPrice(product.priceHuf)}
            {product.unitLabel ? <span> / {product.unitLabel}</span> : null}
          </p>
          {description ? <p className="shop-modal-desc">{description}</p> : null}

          {product.available ? (
            <div className="shop-modal-actions">
              <QuantityStepper value={quantity} onChange={setQuantity} t={t} />
              <button
                type="button"
                className="shop-add shop-add--lg"
                onClick={() => onAdd(product, quantity)}
              >
                <IconBag className="shop-add-icon" />
                {t.addToCart} · {formatPrice(product.priceHuf * quantity)}
              </button>
            </div>
          ) : (
            <p className="shop-modal-soldout">{t.soldOut}</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProductModal;
